//WorkflowEditorType.ts

/**
 * ワークフローエディターで使用するデータ型
 */
export interface WorkFlowEditorType {
    applicationFormatId: string; // 申請書Id
    type: typeData; // 申請種別
    code: string; // 申請書コード
    version: string; // バージョン
    name?: string; // 申請書名
    description?: string; // サブタイトル
    isDeleted: boolean; // 削除フラグ
    isDraft: boolean; // 一時保存フラグ
    appActivityList?: appActivity[]; // 既存のワークフローアクティビティ一覧
    selectTypeList?: typeData[]; // 申請種別選択肢一覧
    selectTemplateList?: templateData[]; // 共通テンプレート一覧
    selectMailTemplateList?: MailTemplateData[]; // メールテンプレート一覧
    selectApproverList?: Approver[]; // 共通照査者一覧
    selectReporterList?: Reporter[]; // 共通報告者一覧
    selectToUserList?: ToUser[]; // メール宛先一覧
    formItems: FormData[]; // フォームアイテム一覧
}

/**
 * 申請種別データ型
 */
export interface typeData {
    id: string;
    typeName: string; // 申請種別名
}

/**
 * アクティビティデータ型
 */
export interface appActivity {
    applicationActivityId: string; // アクティビティId
    order: number; // 実行順序
    appActivityName: string; // アクティビティ名
    defaultConfig: DefaultConfig; // 照査条件設定
    template: templateData; // アクティビティテンプレート
    mailTemplate?: MailTemplateData; // メールテンプレート（任意）
    mailFormat?: MailFormatData; // メールフォーマット（任意）
    reporterList?: Reporter[]; // 報告者一覧（任意）
}

/**
 * アクティビティテンプレートデータ型
 */
export interface templateData {
    id: string;
    templateName: string; // テンプレート名
    code: string; // テンプレート識別コード
}

export interface MailTemplateData {
    id: string;
    name: string;
    description: string;
    subject: string;
    body: string;
    toUsers?: ToUser[];
}

export interface MailFormatData {
    id: string;
    subject: string;
    body: string;
    toUsers?: ToUser[];
}

export interface ToUser {
    id: string;
    firstName: string;
    lastName: string;
}

export interface Reporter {
    id: string;
    firstName: string;
    lastName: string;
}
export interface Approver {
    id: string;
    firstName: string;
    lastName: string;
}
/**
 * フォームアイテムデータ型
 */
export interface FormData {
    formId: string; // フォームアイテムId
    itemOrder?: number; // 表示順序
    label: string; // ラベル名
    type?: string; // フォームアイテム種別
    isRequired?: boolean; // 必須項目フラグ
    defaultValue?: string; // デフォルト値
    selectItemList?: CustomFormSelectItem[]; // 選択肢一覧（typeが"select"の場合）
}

/**
 * 選択リスト項目データ型
 */
export interface CustomFormSelectItem {
    id: string;
    selectOrder: number; // 表示順序
    value: string; // 選択肢の値
    label: string; // 選択肢の表示名
}

// defaultConfig 
export interface DefaultConfig {
    approval?: ConditionConfig; //承認条件（照査アクティビティ）
    rejection?: ConditionConfig; //却下条件（照査アクティビティ）
    mail?: {
        recipientTargets?: MailRecipientTargets;
    };
}

export type MailRecipientTargets = {
    applicant?: boolean;
    approver?: boolean;
    referent?: boolean;
};

// 照査条件定義
export interface ConditionConfig {
    type: ApprovalType | RejectionType;
    details: null | ConditionDetails;
}


export type ConditionDetails = PercentageDetails | UserDetails;

// details
export interface PercentageDetails {
    requiredPercent: number;//照査条件は"PERCENTAGE_XX"の場合
}
export interface UserDetails {
    userList: Approver[]; //照査条件はCONDITIONAL_XXの場合
}

// 条件分類
export type ApprovalType =
    | "ALL_APPROVED"
    | "ANY_APPROVED"
    | "MAJORITY_APPROVED"
    | "PERCENTAGE_APPROVED"
// バックエンド未実装のため一時的に非表示
// | "CONDITIONAL_APPROVED";
export type RejectionType =
    | "ANY_DENIED"
    | "MAJORITY_DENIED"
    | "PERCENTAGE_DENIED"
// バックエンド未実装のため一時的に非表示
// | "CONDITIONAL_DENIED";

// 承認条件の選択肢定義（UIドロップダウン用）
export const approvalTypeOptions: { value: ApprovalType; label: string }[] = [
    { value: "ALL_APPROVED", label: "全員承認" },
    { value: "ANY_APPROVED", label: "誰か1人承認" },
    { value: "MAJORITY_APPROVED", label: "過半数承認" },
    { value: "PERCENTAGE_APPROVED", label: "割合承認" },
    // バックエンド未実装のため一時的に非表示
    // { value: "CONDITIONAL_APPROVED", label: "条件付き承認" }
];
// 却下条件の選択肢定義（UIドロップダウン用）
export const rejectionTypeOptions: { value: RejectionType; label: string }[] = [
    { value: "ANY_DENIED", label: "誰か1人却下" },
    { value: "MAJORITY_DENIED", label: "過半数却下" },
    { value: "PERCENTAGE_DENIED", label: "割合却下" },
    // バックエンド未実装のため一時的に非表示
    // { value: "CONDITIONAL_DENIED", label: "条件付き却下" }
];
